import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button ,DropdownItem , DropdownMenu , Nav , NavItem, Dropdown , DropdownToggle,Label,FormGroup, Input,InputGroup} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";


import * as actions from '../../actions/movimientoalmacen';
// import Modal from "./Modal";
import _ from "lodash";
import {api} from '../../actions/_request';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import moment from 'moment';

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import ModalTablas from '../../components/catalogos/modal_tablas';
import ProductosModal from "./ProductosModal";
import Proveedor from "../proveedores/Modal";
import Almacen from "../almacenes/Modal";

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };
const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);

class Descuentos extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
          movimiento:{
            id:null,
            concepto:this.props.title,
            proveedor_id:0,
            cliente_id:0,
            usuario_id:0,
            almacen1_id:0,
            almacen2_id:0,
            referencia:'',
            fecha: moment().format('Y-MM-DD'),
            pedimento:'',
            fecha_pedimento:null,
            folio:'',
            caja:'',
            importe:'0.00',
            tipo:1,
            tipo_movimiento_id:this.props.tipo,
          },
          action:'save',
             /*variables para el modal de tablas*/
            modal:false,
            titulo:'',
            tabla_modal:0,
            campo_modal:'',
             /**variables para el modal de productos*/
            modal_productos:false,
            renglon:[],
            indice:null,
            productos:[],

            /*modal para agrgar nuevos registros*/
            modal_registro:0,
            tittle_registro:'',


        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);  

        this.toggle_productos= this.toggle_productos.bind(this); 
        this.producto_modal= this.producto_modal.bind(this); 
        this.eliminar_producto= this.eliminar_producto.bind(this);

        this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
         this.toggle_modal_registro= this.toggle_modal_registro.bind(this); 


      

    }

    modal_open(){
       document.getElementById('body').className = "modal-open modal-open";
    }
    toggle_modal_registro(objeto,opcion=0,titulo=''){
      // console.log('opcion---->'+opcion);
      if(opcion==0||opcion=='[object Event]'){
        // console.log('se agrega un modal-open')
        // setTimeout(this.modal_open, 1000);
         
         //if(this.state.tabla_modal==14)
        //  document.getElementById('body').className = "modal-open modal-open";

        this.setState({
            modal : false,
            modal_productos:false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }else{
        console.log('nada')
        this.setState({
            modal : false,
            modal_productos:false,
            modal_registro:this.state.tabla_modal,
            tittle_registro:titulo,
            titulo:"",
            tabla_modal:"",
            campo_modal:"",         
        })

      }
    }

    toggle_productos(index="nuevo",renglon=[]){
        let {movimiento} = this.state;
        console.log('renglon modal-->',renglon);
        console.log('Indice--->',index);
         
          
            this.setState({
                indice:index,
                modal_productos : !this.state.modal_productos, 
                renglon:renglon,        
            })

          
          
    }
    producto_modal(renglon,accion){
      var productos = this.state.productos;
      var movimiento = this.state.movimiento;
      var i=parseInt(this.state.indice);
      if(accion=="save"){
       productos.unshift(renglon);
      }else{
        productos[i]=renglon;

      }
      this.calcular_totales(productos,movimiento);

    }

    eliminar_producto(index){
      var productos = this.state.productos;
      var movimiento = this.state.movimiento;

      swal({
        title: 'Estas seguro?',
        text: "Se eliminara  el producto de la lista!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
         cancelButtonText: 'Cancelar!'
      }).then((result) => {
        if (result.value) {
             productos.splice(index, 1);
             this.calcular_totales(productos,movimiento);

        }
      })
    } 

    calcular_totales(productos,movimiento){
      
      let importe=0;
      

      for (var i = productos.length - 1; i >= 0; i--) {
        importe+=parseFloat( productos[i].importe);
      

      }

 
      movimiento.importe=this.trunc(importe,2);

      this.setState({
            movimiento : movimiento,
            productos : productos,


        });

    }

        trunc (sVal, nDec = 0) {
  // var s = x.toString()
  // var l = s.length
  // var decimalLength = s.indexOf('.') + 1
  // var numStr = s.substr(0, decimalLength + posiciones)
  // return Number(numStr)


    var n = parseFloat(sVal); 
    var s = "0.00"; 
    if (!isNaN(n)){ 
     n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
     s = String(n); 
     s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
     s = s.substr(0, s.indexOf(".") + nDec + 1); 
    } 
    return s; 
}

     handleClose (event) {
        console.log('evento--->',event)
         
        let {movimiento} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        
         switch (name) {
            case "cliente_codigo":                  
                  campo = "cliente_id";
                  tabla="/busqueda_cliente";
                  break;
            case "proveedor_codigo":                                  
                  campo = "proveedor_id";
                  tabla="/proveedor";                   
                  break;
            case "usuario_codigo":                  
                  campo = "usuario_id";
                  tabla="/busqueda_usuario";
                  break;
            case "almacen1_codigo":                 
                  campo = "almacen1_id";
                  tabla="/busqueda_almacen";
                  break;
            case "almacen2_codigo":                  
                  campo = "almacen2_id";
                  tabla="/busqueda_almacen";
                  break;      
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        /*aqui va el request para buscar el saldo*/
                        let  retorno=response.data
                        if(campo=="proveedor_id"){
                            // retorno.saldo="falta funcion";
                        }

                         self.retorno(retorno,campo,vaciar,value);
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }
                            
                   
                }

            });
        }else{
            self.retorno([],campo,1,value); 
        }
            

   }

    ChangeCode(event) {
     
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
     
        this.setState({
            [name] : value
        });
    }

    retorno(objeto,campo,vacio=0,valor=""){
        let codigo="";
        let descripcion="";
        let campo_codigo="";
        let campo_descripcion="";
        let saldo="$0.00";
        let credito="$0.00";
        let bandera=false;
        console.log('renglon---->',objeto);
        let {movimiento} = this.state;
        let self =this;
        console.log('campo---->',campo)
        switch (campo) {
            case "proveedor_id":
                  codigo=objeto.value?objeto.value:objeto.id;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="proveedor_codigo";
                  campo_descripcion="proveedor_descripcion"; 
                  movimiento[campo] = objeto.value?objeto.value:objeto.id;
                  saldo=objeto.saldo;
                  credito=objeto.credito_formato;
                  bandera=true;
                  break;
            case "almacen1_id":
                  codigo=objeto.codigo;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="almacen1_codigo";
                  campo_descripcion="almacen1_descripcion"; 
                  movimiento[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "almacen2_id":
           
                  codigo=objeto.codigo;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="almacen2_codigo";
                  campo_descripcion="almacen2_descripcion"; 
                  movimiento[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "cliente_id":           
                  codigo=objeto.value;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="cliente_codigo";
                  campo_descripcion="cliente_descripcion"; 
                  movimiento[campo] = objeto.value?objeto.value:objeto.id;
                  break;
            case "usuario_id":           
                  codigo=objeto.value;
                  descripcion=objeto.label?objeto.label:objeto.nombre;
                  campo_codigo="usuario_codigo";
                  campo_descripcion="usuario_descripcion"; 
                  movimiento[campo] = objeto.value?objeto.value:objeto.id;
                  break;
               
        }  
       if(vacio==1){
        console.log('vaciar')
        codigo=valor;
        descripcion="";
        movimiento[campo] =0;
       }

       console.log('descripcion--->',descripcion);

       
         self.setState({
            movimiento : movimiento,           
            [campo_codigo]:codigo,
            [campo_descripcion]:descripcion,
            modal:false,         
        })

    
       


    }
    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }   

 
    handleInputChange(event) {
        let {movimiento} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        movimiento[name] = value;
     
        this.setState({
            movimiento : movimiento
        });
    }
  

    componentDidMount()
    {
         
        let id = this.props.id;
        let self = this;
              
        if(id > 0 )
        {

            api().get(`movimientosalmacen/${id}`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        movimiento: response.data.movimiento,
                        action: 'update',
                        proveedor_codigo:response.data.proveedor.codigo,
                        proveedor_descripcion:response.data.proveedor.nombre,
                        cliente_codigo:response.data.cliente.codigo,
                        cliente_descripcion:response.data.cliente.nombre,
                        usuario_codigo:response.data.usuario.codigo,
                        usuario_descripcion:response.data.usuario.nombre,

                        almacen1_codigo:response.data.almacen1.codigo,
                        almacen1_descripcion:response.data.almacen1.nombre,
                        almacen2_codigo:response.data.almacen2.codigo,
                        almacen2_descripcion:response.data.almacen2.nombre,
                        productos:response.data.productos
                    });

                }

            });
        }else{
          api().get(`parametros/1`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                   movimiento: {
                ...self.state.movimiento,
                 almacen1_id:response.data.almacen.id
                },
                almacen1_codigo:response.data.almacen.codigo,
                almacen_descripcion:response.data.almacen.nombre

               })

                }

            });
        }
    }

    objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     if(key!="lista"){
                       objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     }
                        
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }

    handleSubmit(evt)
    {
        evt.preventDefault();
        let {movimiento,productos} = this.state;
        let action=this.state.action;
        
        let save=true;
        let mensaje=true;
        let dato="";
        let self = this;        
        
            let check = ['referencia','concepto','fecha'];
            let check2 = [ 'almacen1_id'];
            //animals.push('chickens');

            switch(parseInt(movimiento.tipo_movimiento_id)){
                case 1:
                  console.log('entrada');
                  
                  break;
                case 2:
                  console.log('Salida');
                  check2.push('usuario_id');
                  break;
                case 3:
                  console.log('Transferencia');
                  check2.push('almacen2_id');
                
                  break;
                case 4:
                  console.log('Proveedor');
                  check2.push('usuario_id');
                  check2.push('proveedor_id');
                  break;
                case 5:
                  console.log('Cliente');
                  check2.push('usuario_id');
                  check2.push('cliente_id');
                  check.push('folio');
                  check.push('caja');
                  check.push('tipo');
                  break;
              }

            for(let i in check) {

            let key = check[i];

            let value = movimiento[key];
            dato=key;

            if(value == '' || value == null){
                save = false;
                break;
            }
                
            }
          
            if(save)
            for(let i in check2) {

            let key = check2[i];

            let value = movimiento[key];
            dato=key;

            if(parseInt( value) == 0) {
                save = false;
                break;
            }
                
            }

          
            let lista=[];
            if(save){

              
              if(productos.length === 0) {
                save=false;
                mensaje=false;

                  swal("Oops..", "Por favor Verificar la lista de los productos ");

              }else{

                lista=productos;
              } 
            }

            movimiento.lista=lista;            
             
          
               
        movimiento=this.objeto_mayusculas(movimiento);
        console.log('movimiento--->',movimiento)
        
        if(save   ){

          console.log('movimiento----->' ,movimiento)


          api().post(`/movimientosalmacen_validar`, movimiento)
            .then(function(response)
            {
                let validacion=response.data.validacion;
                let encontrado=response.data.encontrado[0];

                if(validacion||(parseInt(encontrado.id)===parseInt(movimiento.id) )){


                        self.props[action](movimiento, (data) => {
                          self.props.alerta({
                            mensaje:"El Movimiento Guardado correctamente!",
                            tipo:"success",
                            creacion:moment().format('Y-MM-DD H:m:s'),
                            });
                            self.props.cerrar();
                });


                }else{
                    swal("Oops..", "La Referencia ya existe");
                }
            });







                  

           


         

        }else{
          if(productos.length > 0||mensaje==true)
            swal("Oops..", "Por favor Verificar el Campo de " +dato);

        }

        


        

      

    }

    render() {
      let {movimiento}=this.state;

      let entrada=false;
      let salida=false;
      let transferencia=false;
      let proveedor=false;
      let cliente=false;

      switch(parseInt(movimiento.tipo_movimiento_id)){
        case 1:
          console.log('entrada');
          entrada=true;
          break;
        case 2:
          console.log('Salida');
          salida=true;
          break;
        case 3:
          console.log('Transferencia');
          transferencia=true;
          break;
        case 4:
          console.log('Proveedor');
          proveedor=true;
          break;
        case 5:
          console.log('Cliente');
          cliente=true;
          break;
      }
 
        return(
            <div className="view">
                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Movimiento {this.props.title}</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                          <div className="row justify-content-end">
                            <div className="col-3 mb-4">
                              <div className="mr-5 text-right float-right">
                                {
                                  this.props.movimientoalmacen.saving ?
                                    <SubmitLoad /> : 
                                    <div>
                                      <Button color="primary" type="submit"  onClick={this.handleSubmit} >
                                      <IconSave />&nbsp;Guardar
                                      </Button>{' '}
                                      <Button color="secondary" onClick={this.props.cerrar}>
                                      Cancelar
                                      </Button>
                                    </div>
                                } 
                              </div>
                            </div>
                          </div>
                          <div className="row">
                          <div className="col-6">
                            <div className="row">
                            <div className="col-12">
                                <FormGroup>
                                    <Label>Concepto</Label>
                                        <Input
                                        placeholder=""
                                        type="text"
                                        name="concepto"
                                        maxLength={75}
                                        value={movimiento.concepto} 
                                        onChange={this.handleInputChange}  />
                                </FormGroup>
                            </div>

                            { proveedor&&
                            <div className="col-4"> 
                                    <div className="form-group">
                                        <label className="d-block">Proveedor:</label>
                                        <Input
                                        placeholder=""
                                        type="number"
                                        name="proveedor_codigo"
                                        value={this.state.proveedor_codigo}
                                         onChange={ this.ChangeCode}
                                         onBlur={this.handleClose}
                                        className="input_button"
                                      
                                       
                                        />
                                        <Button onClick={ (button) => { this.toggle_modal(14,"Proveedores","proveedor_id") } } >...</Button>
                                    </div>
                                </div>
                                }
                                 { proveedor&&
                                <div className="col-7 pt-4">
                                    <label className="">{this.state.proveedor_descripcion}</label>
                                </div>
                                }
                                { cliente&&
                                <div className="col-4"> 
                                        <div className="form-group">
                                            <label className="d-block">Cliente:</label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="cliente_codigo"
                                            value={this.state.cliente_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                            className="input_button"
                                          
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(30,"Clientes","cliente_id") } } >...</Button>
                                        </div>
                                    </div>
                                }
                                { cliente&&
                                <div className="col-7 pt-4">
                                    <label className="">{this.state.cliente_descripcion}</label>
                                </div>
                               }
                                <div className="col-4">
                                    <FormGroup>
                                        <Label>Referencia</Label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="referencia"
                                            maxLength={45}
                                            value={movimiento.referencia} 
                                            onChange={this.handleInputChange}  />
                                    </FormGroup>
                                </div>
                                <div className="col-4">
                                    <div className="form-group">
                                        <label className>Fecha:</label>
                                        <input
                                            type="date" 
                                            className="form-control"
                                            name="fecha"
                                            value={movimiento.fecha || ''}
                                            onChange={this.handleInputChange}
                                           
                                        />
                                    </div>
                                </div>
                                <div className="col-4"></div>
                                { (false)&&
                                <div className="col-4">
                                    <FormGroup>
                                        <Label>Pedimento</Label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="pedimento"
                                            maxLength={45}
                                            value={movimiento.pedimento} 
                                            onChange={this.handleInputChange}  />
                                    </FormGroup>
                                </div>
                              }
                              { (false)&&
                                <div className="col-4">
                                    <div className="form-group">
                                        <label className>Fecha:</label>
                                        <input
                                            type="date" 
                                            className="form-control"
                                            name="fecha_pedimento"
                                            value={movimiento.fecha_pedimento || ''}
                                            onChange={this.handleInputChange}
                                           
                                        />
                                    </div>
                                </div>
                              }
                                <div className="col-4"></div>

                              

                            </div>
                          </div>
                           <div className="col-6">
                            <div className="row">
                            { (salida||proveedor||cliente)&&
                            <div className="col-4"> 
                                        <div className="form-group">
                                            <label className="d-block">vendedor:</label>
                                            <Input
                                            placeholder=""
                                            type="number"
                                            name="usuario_codigo"
                                            value={this.state.usuario_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                            className="input_button"
                                          
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(31,"Usuarios","usuario_id") } } >...</Button>
                                        </div>
                                    </div>
                                  }
                                { (salida||proveedor||cliente)&&
                                <div className="col-7 pt-4">
                                    <label className="">{this.state.usuario_descripcion}</label>
                                </div>
                               }
                                <div className="col-4"> 
                                        <div className="form-group">
                                            <label className="d-block">Del Almacen:</label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="almacen1_codigo"
                                            value={this.state.almacen1_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                            className="input_button"
                                          
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(25,"Almacenes","almacen1_id") } }>...</Button>
                                        </div>
                                    </div>
                                    
                                <div className="col-4"> 
                                { (transferencia)&&
                                        <div className="form-group">
                                            <label className="d-block">Al Almacen:</label>
                                            <Input
                                            placeholder=""
                                            type="text"
                                            name="almacen2_codigo"
                                            value={this.state.almacen2_codigo}
                                             onChange={ this.ChangeCode}
                                             onBlur={this.handleClose}
                                            className="input_button"
                                          
                                           
                                            />
                                            <Button onClick={ (button) => { this.toggle_modal(25,"Almacenes","almacen2_id") } }>...</Button>
                                        </div>
                                      }
                                    </div>
                                 
                                    <div className="col-4"></div>
                                    { (cliente)&&
                                    <div className="col-4">
                                        <FormGroup>
                                            <Label>Folio</Label>
                                                <Input
                                                placeholder=""
                                                type="text"
                                                name="folio"
                                                maxLength={15}
                                                value={movimiento.folio} 
                                                onChange={this.handleInputChange}  />
                                        </FormGroup>
                                    </div>
                                  }
                                  { (cliente)&&
                                    <div className="col-4">
                                        <FormGroup>
                                            <Label>Caja</Label>
                                                <Input
                                                placeholder=""
                                                type="text"
                                                name="caja"
                                                maxLength={15}
                                                value={movimiento.caja} 
                                                onChange={this.handleInputChange}  />
                                        </FormGroup>
                                    </div>
                                  }
                                     <div className="col-4"></div>
                                     { (cliente)&&
                                     <div className="col-4 div_titulo">
                                                    <h1><span>Tipo</span></h1>
                                                        <FormGroup tag="fieldset">
                                                            <FormGroup check>
                                                                <Label check>
                                                                    <Input type="radio" value="1" name="tipo" onChange={ this.handleInputChange} checked={parseInt(movimiento.tipo)===1?true:false} />{' '}
                                                                    Factura
                                                                </Label>
                                                            </FormGroup>
                                                            <FormGroup check>
                                                                <Label check>
                                                                    <Input type="radio" value="2" name="tipo" onChange={ this.handleInputChange} checked={parseInt(movimiento.tipo)===2?true:false} />{' '}
                                                                    Recibo
                                                                </Label>
                                                            </FormGroup>
                                                        </FormGroup>
                                                   
                                        </div>
                                      }

                            </div>
                           </div>
                          </div>

                          <div className="row">
                          <div className="col-md-12 text-right">
                                        <Button color="success" className="mb-2"  onClick={()=>this.toggle_productos(null,[])}>
                                    &nbsp;Agregar
                                </Button>
                                    </div>
                          <div className="col-md-12">    
                                                <ReactTable
                                                  getTrProps={(state, rowInfo, column) => {                                  
                                                      if(rowInfo === undefined){                                          
                                                              return{
                                                              }
                                                            }else{
                                                               return{
                                                                onDoubleClick: (evt)=>this.toggle(evt, rowInfo.original.value, 'Editar Usuario')
                                                            }                                   
                                                        }
                                                  }}
                                                  data      = {this.state.productos}
                                                  className = "-striped -highlight"
                                                  columns   = {[

                                                    {
                                                        Header: 'Controles',
                                                        filterable: false,
                                                        sortable: false,
                                                        maxWidth:150,
                                                        Cell: (row) =>
                                                        {
                                                            return(
                                                                <div className="text-right">
                                                                <Button
                                                                     color="primary" 
                                                                     className="btn-sm" 
                                                                     onClick={()=>this.toggle_productos(row.index,row.original)}>
                                                                        <IconEdit />
                                                                    </Button>{' '}
                                                                    <Button
                                                                     color="danger" 
                                                                     className="btn-sm" 
                                                                     onClick={()=>this.eliminar_producto(row.index)}>
                                                                        X
                                                                    </Button>{' '}
                                                                     
                                                                </div>
                                                            )
                                                        }
                                                    },
                                                   
                                                    {Header: 'Clave', accessor: 'codigo',maxWidth:100,minWidth:100 , style: { 'textAlign': 'center'}},
                                                    {Header: 'Descripción', accessor: 'nombre' ,minWidth:500, style: { 'textAlign': 'center'}},                    
                                                    {Header: 'Unidades', accessor: 'cantidad',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}}, 
                                                    {Header: 'Costo', accessor: 'costo',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}}, 
                                                    {Header: 'Importe', accessor: 'importe',maxWidth:100,minWidth:100, style: { 'textAlign': 'center'}},
                                                  ]}
                                                  filterable 
                                                 pageSizeOptions= {[5]}  defaultPageSize={5} 
                                                   defaultFilterMethod={filterCaseInsensitive}
                                                />
                                    </div>

                          </div>
                          <div className="row justify-content-end">
                           <div className="col-md-3">
                                        <div className="row mt-3">
                                           
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>Importe: </Label></h5>
                                                </FormGroup>
                                            </div>
                                            <div className="col-6 text-left">
                                                <FormGroup>
                                                    <h5><Label>{"$"+movimiento.importe}</Label></h5>
                                                </FormGroup>
                                            </div>
                                        </div>
                                    </div>
                           
                         
                                

                        
                          </div>
                          <br/>
                          <br/>
                          <br/>
                          <br/>
                          <div className="row justify-content-end">
                            <div className="col-3 mb-4">
                              <div className="mr-5 text-right float-right">
                                {
                                  this.props.movimientoalmacen.saving ?
                                    <SubmitLoad /> : 
                                    <div>
                                      <Button color="primary" type="submit"  onClick={this.handleSubmit} >
                                      <IconSave />&nbsp;Guardar
                                      </Button>{' '}
                                      <Button color="secondary" onClick={this.props.cerrar}>
                                      Cancelar
                                      </Button>
                                    </div>
                                } 
                              </div>
                            </div>
                          </div>

                        </CardBlock>
                    </Card>
                </div>
                { this.state.modal&&
                 <ModalTablas
                    open={this.state.modal}
                    toggle={this.toggle_modal}                  
                    titulo={this.state.titulo}
                    catalogo={this.state.tabla_modal}
                    retorno={this.retorno}
                    campo={this.state.campo_modal}
                    agregar={this.toggle_modal_registro}
                />
                }
                 {
                   this.state.modal_productos&&
                   <ProductosModal 
                 open={this.state.modal_productos} 
                 toggle={this.toggle_productos} 
                 title={"Producto"} 
                 renglon={this.state.renglon}
                 retorno={this.producto_modal}
                 id={this.state.indice}                   
                />
                }

                {
                   this.state.modal_registro==14&& 
                   <Proveedor 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
                 {
                   this.state.modal_registro==25&& 
                   <Almacen 
                 open={this.state.modal_registro>0?true:false} 
                 toggle={this.toggle_modal_registro} 
                 title={this.state.tittle_registro} 
                 prospectoid={null}
                />
                }
            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        movimientoalmacen : state.movimientoalmacen,
        notificciones:state.notificciones,
    }
};

export default connect(mapStateToProps, actions)(Descuentos)


// WEBPACK FOOTER //
// ./src/views/movimientosAlmacenes/movimiento.js